import { useCallback, useMemo, useState } from 'react'

export function useLibrarySelection({ mode = 'multiple' } = {}) {
  const [selectedItems, setSelectedItems] = useState([])

  const selectedIds = useMemo(
    () => selectedItems.map(({ item }) => item.id),
    [selectedItems],
  )

  const createSetSelectedMedia = useCallback(
    (availableItems = []) => (updater) => {
      setSelectedItems((prevItems) => {
        const prevIds = prevItems.map(({ item }) => item.id)
        let nextIds = typeof updater === 'function' ? updater(prevIds) : updater

        if (mode === 'single') {
          const newlySelected = nextIds.find((id) => !prevIds.includes(id))

          nextIds = newlySelected
            ? [newlySelected]
            : nextIds.filter((id) => prevIds.includes(id))
        }

        return nextIds
          .map((id) =>
            prevItems.find(({ item }) => item.id === id)
            ?? availableItems.find(({ item }) => item.id === id))
          .filter(Boolean)
      })
    },
    [mode],
  )

  const deselectAll = useCallback(() => {
    setSelectedItems([])
  }, [])

  return {
    selectedItems,
    selectedIds,
    createSetSelectedMedia,
    deselectAll,
  }
}
